import { useBreakpointValue } from "@chakra-ui/react";

export type ScreenSize = "mobile" | "tablet" | "desktop";

export const useScreenSize = (): ScreenSize => {
  return (
    useBreakpointValue({ base: "mobile", md: "tablet", lg: "desktop" }) ??
    "desktop"
  );
};
